import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { path } from 'ramda';

import { isNilOrEmpty } from '../../../../../../util/redux';
import { toCurrency, validStripeId } from '../../../../../../util/helpers';
import registrationActions from '../../../../../../redux/registration/index';
import { handleErrorBase, handleSuccessBase } from '../../../../../../util/forms';
import { apiOverridePrice } from '../../../../../../api/registration';

const mapStore = ({ registration }) => ({
  registration,
});

const mapDispatch = {
  ...registrationActions,
};

class FinalPrice extends Component {
  static propTypes = {
    lineItem: PropTypes.object,
    productless: PropTypes.bool,
    readonly: PropTypes.bool,
    registration: PropTypes.object,
    updateRegistration: PropTypes.func,
    override: PropTypes.number,
    hidePrice: PropTypes.bool,
  };

  state = {
    editing: false,
    newPrice: '',
  };

  saveNewPrice = () => {
    const { lineItem, registration, updateRegistration } = this.props;
    const { newPrice } = this.state;

    apiOverridePrice(registration.id, { ...lineItem, price: newPrice })
      .then(({ data }) => updateRegistration(data))
      .then(() => handleSuccessBase('Price changed'))
      .then(this.toggleEditing)
      .catch(() => handleErrorBase('Could not change price'));
  };

  toggleEditing = () => {
    const { lineItem } = this.props;
    const { editing } = this.state;

    this.setState({ editing: !editing, newPrice: toCurrency(lineItem.finalPrice, '') });
  };

  renderRegular = () => {
    const { lineItem, productless, readonly, override, hidePrice } = this.props;
    const paid = !isNilOrEmpty(lineItem.transactionId);
    const stripeTransaction = path(['transaction', 'stripeId'], lineItem);
    const canEdit = !paid && !readonly;

    return (
      <div>
        {!hidePrice && toCurrency(productless ? lineItem.price : override ? override : lineItem.finalPrice)}
        {paid &&
          (stripeTransaction && validStripeId(stripeTransaction) && !readonly ? (
            <a
              href={`https://dashboard.stripe.com/payments/${stripeTransaction}`}
              target="_blank"
              className="badge badge-success ml-1"
            >
              Paid
            </a>
          ) : (
            <span className="badge badge-success ml-1">Paid</span>
          ))}
        {canEdit && (
          <button type="button" className="badge badge-primary ml-1" onClick={this.toggleEditing}>
            Edit
          </button>
        )}
      </div>
    );
  };

  renderEditing = () => {
    const { newPrice } = this.state;

    return (
      <div>
        $<input type="number" onChange={({ target }) => this.setState({ newPrice: target.value })} value={newPrice} />
        <button type="button" className="badge badge-primary ml-1" onClick={this.saveNewPrice}>
          Save
        </button>
        <button type="button" className="badge ml-1" onClick={this.toggleEditing}>
          Cancel
        </button>
      </div>
    );
  };

  render() {
    if (isNilOrEmpty(path(['finalPrice'], this.props.lineItem)) && !this.props.productless) return <noscript />;
    if (this.state.editing) return this.renderEditing();

    return this.renderRegular();
  }
}

export default connect(mapStore, mapDispatch)(FinalPrice);
